module.exports = __webpack_public_path__ + "img/P150T_weapon_100.09a43f1d.png";